import { render, staticRenderFns } from "./ListaDestinos.vue?vue&type=template&id=30200797&"
import script from "./ListaDestinos.vue?vue&type=script&lang=js&"
export * from "./ListaDestinos.vue?vue&type=script&lang=js&"
import style0 from "./ListaDestinos.vue?vue&type=style&index=0&id=30200797&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports